<template>
  <div id="tuiImageEditor" v-bind:class="{ imageEditor: changed }">
    <div class="imageEditorApp" v-if="changed">
      <image-editor-container></image-editor-container>
    </div>
  </div>
</template>
<script>
// Load Style Code
import 'tui-image-editor/dist/tui-image-editor.css';
import 'tui-color-picker/dist/tui-color-picker.css';
import { ImageEditor } from '@toast-ui/vue-image-editor';
import ImageEditorContainer from './ImageEditorContainer';

import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'EditorImageComponent',
  components: {
    'tui-image-editor': ImageEditor,
    ImageEditorContainer
  },

  data() {
    return {
      changed: false
    };
  },
  computed: {
    ...mapGetters({
      imageEdited: 'common/getImageEdited'
    })
  },
  created() {
    eventHub.$on('eventShowEditorImage', this.eventShowEditorImage);
  },
  methods: {
    eventShowEditorImage(show) {
      this.changed = show;
    }
  },
  mounted() {}
};
</script>
<style lang="scss">
.imageEditorApp {
  position: relative;
  display: inline-block;
  overflow: hidden;
  max-height: calc(100vh - 5%);
  margin: 5% auto 20px;
  max-width: 1000px;
  width: 90%;
  height: 100%;
}
.imageEditor {
  position: absolute;
  top: 0;
  z-index: 9;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}
</style>



// WEBPACK FOOTER //
// EditorImageComponent.vue?1649fa17